"use client";

import { useState, useEffect } from "react";

export function useKlaroConsent(serviceName: string) {
  const [consent, setConsent] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      if (typeof (window as any).klaro !== "undefined") {
        try {
          const manager = (window as any).klaro.getManager();
          if (manager) {
            const hasConsent = manager.getConsent(serviceName);
            
            // Nur updaten, wenn sich der Wert wirklich geändert hat
            setConsent((prev) => {
              if (prev !== hasConsent) return hasConsent;
              return prev;
            });
            
            setLoaded(true);
            return true;
          }
        } catch (e) {
          console.error("Klaro error:", e);
        }
      }
      return false;
    };

    // Initialer Check
    checkConsent();

    // Polling Intervall: Prüft alle 500ms, ob Klaro da ist oder sich der Status geändert hat.
    // Das ist wichtig für Next.js Transitions, da Klaro keine Events feuert.
    const interval = setInterval(checkConsent, 500);

    return () => {
      clearInterval(interval);
    };
  }, [serviceName]);

  const showModal = () => {
    if (typeof (window as any).klaro !== "undefined") {
      (window as any).klaro.show();
    }
  };

  return { consent, loaded, showModal };
}